import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import NumberFormat from 'react-number-format';
// import { MAX_LIMIT } from 'modules/common/constants';

import * as actions from '../action';
import * as c from '../constant';

function DeductTaxCreditModal({
  deductTaxCredit,
  id,
  deducting,
  getSingleNewBusinesses,
  maxAmount,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    amount: '',
    notes: '',
  });

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
    };

    deductTaxCredit(id, args, () => {
      setModal({ isOpen: false });
      getSingleNewBusinesses(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="amount" className="form-label mb-0">
              Amount 
            </label>
            <NumberFormat
              name="amount"
              id="amount"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                const amountValue = _.isNil(floatValue) ? '' : Math.min(floatValue, maxAmount);
                setFormData({
                  ...formData,
                  amount: amountValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'amount', '')}` || ''}
              placeholder={maxAmount}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Notes 
            </label>
            <input
              className="form-control"
              type="text"
              min="3"
              name="notes"
              onChange={onChange}
              value={_.get(formData, 'notes') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={deducting}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {deducting ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={deducting}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

DeductTaxCreditModal.propTypes = {
  deductTaxCredit: PropTypes.instanceOf(Function).isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  deducting: PropTypes.bool.isRequired,
  maxAmount: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  deducting: api.loading.indexOf(c.DEDUCT_TAX_CREDIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DeductTaxCreditModal);
